export function getElementOrder(elementOrderArray, elementsInSection, page) {
  if (elementOrderArray.length === 0) {
    return elementsInSection;
  }
  const elementOrderArrayKeys = Object.keys(elementOrderArray).map((k) =>
    parseInt(k)
  );
  const index = elementOrderArrayKeys.reduce(
    (accum, curr) => (curr > accum && curr <= page) ? curr : accum,
    0,
  );

  if (index === 0) {
    return [];
  }
  return elementOrderArray[index];
}

export function measureRangeCheck(measureRanges, page) {
  for (let i = 0; i < measureRanges.length; i++) {
    let mR = measureRanges[i];
    if (mR[0] === 1 && mR[1] === -1) {
      return true;
    } else if (mR[0] <= page && mR[1] >= page) {
      return true;
    } else if (mR[0] <= page && mR[1] === -1) {
      return true;
    }
  }
  return false;
}

export function getElementsInSection(page, section) {
  return section.elements.filter((element) =>
    measureRangeCheck(element.measureRanges, page)
  ).map((e) => e.elementName);
}
export function getSectionOrder(sectionOrderArray, page, staffElements) {
  if (Object.keys(sectionOrderArray).length === 0) {
    const defaultValue = staffElements.sections.map((s) => s.sectionName);
    return defaultValue;
  }
  const sectionOrderArrayKeys = Object.keys(sectionOrderArray).map((k) =>
    parseInt(k)
  );
  const index = sectionOrderArrayKeys.reduce(
    (accum, curr) => (curr > accum && curr <= page) ? curr : accum,
    0,
  );

  if (index === 0) {
    return [];
  }
  return sectionOrderArray[index];
}

export default { measureRangeCheck, getElementsInSection, getElementOrder, getSectionOrder };
